import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton, CircularProgress, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AdvertisementModal = ({ ad, isOpen, onClose, onSkip }) => {
  const [countdown, setCountdown] = useState(ad?.duration ? ad.duration / 1000 : 0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('广告 duration:', ad?.duration, typeof ad?.duration);
    if (!isOpen) return;

    // 重新初始化倒计时
    setCountdown(ad?.duration ? ad.duration / 1000 : 0);

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen, ad?.duration, onClose]);

  const handleSkip = () => {
    setCountdown(0);
    onSkip();
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleAdClick = () => {
    if (ad?.clickUrl) {
      console.log('广告点击，跳转链接:', ad.clickUrl);
      // 跳转到广告链接
      window.open(ad.clickUrl, '_blank');
      // 增加点击计数
      incrementClickCount(ad.id);
    }
  };

  const incrementClickCount = async (adId) => {
    try {
      await fetch(`/api/advertisements/${adId}/clicks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('广告点击计数已更新');
    } catch (error) {
      console.error('更新广告点击计数失败:', error);
    }
  };

  if (!ad) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          borderRadius: 0,
          overflow: 'hidden',
        }}
      >

        {isLoading && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="body1" color="text.secondary">
              加载广告中...
            </Typography>
          </Box>
        )}

        <Box
          onClick={handleAdClick}
          sx={{
            cursor: ad?.clickUrl ? 'pointer' : 'default',
            '&:hover': ad?.clickUrl ? {
              opacity: 0.9,
              transition: 'opacity 0.2s',
            } : {},
          }}
        >
          <img
            src={ad.imageUrl}
            alt={ad.name}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              display: isLoading ? 'none' : 'block',
            }}
            onLoad={handleImageLoad}
            onError={() => setIsLoading(false)}
          />
        </Box>

        <Box
          sx={{
            position: 'absolute',
            bottom: 20,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ color: 'white', textShadow: '1px 1px 2px black' }}>
            广告 {countdown} 秒
          </Typography>
          
          {ad.allowClose && (
            <Button
              variant="contained"
              onClick={handleSkip}
              sx={{
                backgroundColor: 'rgba(0,0,0,0.6)',
                color: 'white',
                fontSize: '1rem',
                fontWeight: 'bold',
                borderRadius: '20px',
                px: 3,
                py: 1,
              }}
            >
              跳过广告
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AdvertisementModal;